/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const TeamIcon = ({
  className,
  style,
  color = '#262626',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="20"
      height="20"
      fill="none"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M6.484 5.605A2.64 2.64 0 0 0 3.848 2.97 2.64 2.64 0 0 0 1.21 5.605a2.64 2.64 0 0 0 2.637 2.637C1.748 8.242 0 9.951 0 12.051v2.636h5.02c0-1.757.92-3.297 2.3-4.184a3.809 3.809 0 0 0-3.472-2.26 2.64 2.64 0 0 0 2.636-2.638Zm3.516 0a2.64 2.64 0 0 1 2.637 2.637A2.64 2.64 0 0 1 10 10.88a2.64 2.64 0 0 1-2.637-2.637A2.64 2.64 0 0 1 10 5.605Zm0 5.274c2.1 0 3.809 1.708 3.809 3.809v2.343H6.19v-2.343c0-2.1 1.709-3.81 3.809-3.81Zm2.68-.376a3.809 3.809 0 0 1 3.472-2.26c2.1 0 3.848 1.708 3.848 3.808v2.636h-5.02a4.972 4.972 0 0 0-2.3-4.184Zm6.11-4.898a2.64 2.64 0 0 0-2.638-2.636 2.64 2.64 0 0 0-2.636 2.636 2.64 2.64 0 0 0 2.636 2.637 2.64 2.64 0 0 0 2.637-2.637Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
